import React from 'react'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-8">
        <img
          src="/404error.svg"
          alt="404 Not Found"
          className="w-[200px] h-[200px] md:w-[270px] md:h-[270px] shadow-lg rounded-full shadow-gray-700"
        />
        <h1 className="text-4xl font-bold text-red-500 font-serif">PAGE NOT FOUND</h1>
        <div className='mt-12'>
          <Link to="/" className="flex items-center border border-sky-300 hover:text-white px-4 py-2 rounded-md hover:shadow-lg shadow-gray-700 hover:bg-sky-500 transition-all duration-300">
            <span className='text-xl'>Home</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound